import React, { useState, useCallback } from "react";
import { Editor, EditorState, CompositeDecorator } from "draft-js";
import styled from "styled-components";
import "draft-js/dist/Draft.css";

// Styled component for borderless editor
const StyledEditor = styled.div`
  width: 100%;

  .DraftEditor-root {
    border: none;
    padding: 10px;
    min-height: 100px;
    width: 100%;
  }
  .public-DraftEditorPlaceholder-root {
    color: #999;
    font-size: 14px;
  }
`;

const DraftEditor = ({ onChange, editorState }) => {
  return (
    <StyledEditor>
      <Editor
        editorState={editorState}
        onChange={onChange}
        placeholder="Write something..."
      />
    </StyledEditor>
  );
};

export default DraftEditor;
